import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { ExternalSystemState } from 'src/app/proxy/external-systems';

@Component({
  selector: 'app-external-system-state-dropdown',
  templateUrl: './external-system-state-dropdown.component.html',
  standalone: false,
})
export class ExternalSystemStateDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() externalSystemState: ExternalSystemState | undefined;

  @Output() changeExternalSystemState = new EventEmitter<ExternalSystemState | undefined>();

  externalSystemStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.isNullOrUndefined(this.externalSystemState)) {
      this.externalSystemState = ExternalSystemState.Active;
    }

    this.loadExternalSystemState();
    this.onSelected();
  }

  loadExternalSystemState(): void {
    this.externalSystemStates = this.getEnumOptions(ExternalSystemState, false);
  }

  onSelected(): void {
    this.changeExternalSystemState.emit(this.externalSystemState);
  }

  setExternalSystemState(state: ExternalSystemState | undefined): void {
    this.externalSystemState = state;
    this.onSelected();
  }
}